import React from 'react';

import { lang, remCss, scssVariables as variables, userFullName, withRouter } from 'src/helpers';

import TreatmentDetail from './TreatmentDetail';
import SVGIcon, { BASE_ICONS } from '../svg';
import { PrivacySetting } from '../complex';
import { Avatar, MCButton } from '../basic';
import LANG_CONST from '../../helpers/lang/const';

const TreatmentItem = React.memo(
  ({
    timeMessage,
    item,
    openId = null,
    onOpenId,
    onPrivacySettings,
    privacySettingsData,
    auth,
    showDoctor,
    router,
    onSeeMore
  }) => {
    const doctor = item.doctor || {};
    return (
      <div className={'mc-list-item'} key={'mc-treatment-list-item-' + item.id}>
        {timeMessage && <div className={'mc-list-item-time'}>{timeMessage}</div>}
        <div className={'mc-b2 mc-radius-5 mc-flex-col mc-p15'}>
          <div
            className={'mc-flex mc-wrap'}
            style={{ justifyContent: 'flex-end', alignItems: 'flex-start' }}
          >
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-value-618'}>{item.data?.diagnosis}</div>
              <pre className={'mc-label-418'}>{item.data?.description}</pre>
            </div>
            <div className={'mc-flex'}>
              {onPrivacySettings && (
                <PrivacySetting
                  title={LANG_CONST.titles.can_view_treatment}
                  onChange={(privacySettings) => {
                    onPrivacySettings({
                      id: item.id,
                      privacySettings
                    });
                  }}
                  data={privacySettingsData}
                />
              )}
              <MCButton onClick={() => onOpenId(item)} tiny quaternary light radius>
                <span
                  className={'mc-rotate ' + (openId === item.id ? 'mc-rotate-180' : '')}
                  style={{ height: remCss(42) }}
                >
                  <SVGIcon
                    iconname={BASE_ICONS.DOWN}
                    width={42}
                    padding={7}
                    fill={variables['colors-mc-orange']}
                  />
                </span>
              </MCButton>
            </div>
          </div>
          {showDoctor && openId !== item.id && (
            <div className={'mc-flex mc-grow'}>
              <Avatar text={userFullName(doctor)} width={60} height={60} image={doctor.avatar} />
              <div className={'mc-flex-5-col'} style={{ minWidth: 0 }}>
                <div className={'mc-value-518'}>{userFullName(doctor, doctor?.isDoctor)}</div>
                <div className={'mc-label-418 mc-text-truncate'}>
                  {doctor.specialist
                    ?.filter((v) => !!LANG_CONST.constants.specialist[v])
                    .map((v) => lang.t(LANG_CONST.constants.specialist[v]))
                    .join(', ')}
                </div>
              </div>
            </div>
          )}
          <div className={' ' + (openId === item.id ? '' : 'mc-hide')}>
            <TreatmentDetail
              item={item}
              showDoctor={showDoctor}
              auth={auth}
              router={router}
              onSeeMore={onSeeMore}
            />
          </div>
        </div>
      </div>
    );
  }
);
TreatmentItem.displayName = 'TreatmentItem';
export default withRouter(TreatmentItem);
